import { ICON_TYPES } from '../constants';

export const BackArrowIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9998 10.9999H8.99982L12.2928 7.70694L10.8788 6.29294L6.58582 10.5859C6.21087 10.961 6.00024 11.4696 6.00024 11.9999C6.00024 12.5303 6.21087 13.0389 6.58582 13.4139L10.8788 17.7069L12.2928 16.2929L8.99982 12.9999H18.9998V10.9999Z"
        fill="#E35205"
      />
    </svg>
  );
};

BackArrowIcon.iconType = ICON_TYPES.BACK_ARROW;
